import { ArrowLeft } from "lucide-react";
import type React from "react";
import type { AppHeaderProps } from "@/types";

interface ExtendedAppHeaderProps extends AppHeaderProps {
	onBack?: () => void;
	showBackButton?: boolean;
	className?: string;
}

const AppHeader: React.FC<ExtendedAppHeaderProps> = ({
	leftContent,
	centerContent,
	rightContent,
	onBack,
	showBackButton = false,
	className = "",
	variant = "default",
}) => {
	return (
		<header className={`app-header app-header--${variant} ${className}`}>
			<div className="app-header-container">
				<div className="app-header-left">
					{showBackButton && onBack && (
						<button className="app-header-back-button" onClick={onBack} type="button">
							<ArrowLeft size={20} />
							Back
						</button>
					)}
					{leftContent}
				</div>

				<div className="app-header-center">{centerContent}</div>

				<div className="app-header-right">{rightContent}</div>
			</div>
		</header>
	);
};

export default AppHeader;
